import {map} from "../../__snowpack__/pkg/lodash.js";
export const MobileRulesMap = {
  CN: [
    {
      pattern: /^(\+?0?86\-?)?1[3456789]\d{9}$/,
      message: "globalsMobileErrorInfo"
    }
  ],
  ID: [
    {
      pattern: /^0?8/,
      message: "globalsMobileErrorInfo"
    },
    {
      min: 9,
      max: 12,
      type: "string",
      message: "globalsMobileErrorInfoLength"
    }
  ],
  PH: [
    {
      pattern: /^(?=\d{10,11}$)(9|09)\d+/,
      message: "globalsMobileErrorInfo"
    },
    {
      min: 10,
      max: 11,
      type: "string",
      message: "globalsMobileErrorInfoLength"
    }
  ],
  TH: [
    {
      min: 9,
      max: 10,
      type: "string",
      message: "globalsMobileErrorInfoLength"
    }
  ],
  VN: [
    {
      min: 9,
      max: 10,
      type: "string",
      message: "globalsMobileErrorInfoLength"
    }
  ],
  MY: [
    {
      min: 9,
      max: 10,
      type: "string",
      message: "globalsMobileErrorInfoLength"
    }
  ]
};
export const validMobileRulesMap = (region, formatMessage) => {
  const getChannelCountry = MobileRulesMap[region];
  return map(getChannelCountry, (item) => {
    return Object.assign({}, item, {
      message: formatMessage({
        id: item.message
      }, item.max && item.min && {min: item.min, max: item.max})
    });
  });
};
